import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { formatListValue } from '@/shared/components/FormattedListValue';
import EnumCacheService from '@/shared/services/EnumCacheService';
import HasMultiCompany from '@/shared/components/security/HasMultiCompany';
import messages from '../generalSettingsMessages';
import TranslateListItemModal from '@/shared/components/translations/TranslateListItemModal';
const profileMessages = defineMessages({
    Responsible: { id: 'Responsible', defaultMessage: 'Responsible' },
    Assistant: { id: 'Assistant', defaultMessage: 'Assistant' },
    AssistantBackup: { id: 'AssistantBackup', defaultMessage: 'AssistantBackup' },
    Associate: { id: 'Associate', defaultMessage: 'Associate' },
    BillingUser: { id: 'BillingUser', defaultMessage: 'BillingUser' },
    SeniorUser: { id: 'SeniorUser', defaultMessage: 'SeniorUser' },
});
const PROFILE_MESSAGE_MAP = {
    1: 'Responsible',
    2: 'Assistant',
    3: 'AssistantBackup',
    4: 'Associate',
    5: 'BillingUser',
    6: 'SeniorUser',
};
const EmployeeProfileTranslationsSection = ({ canUpdate, }) => {
    const intl = useIntl();
    const [employeeProfiles, setEmployeeProfiles] = useState([]);
    const [translateProfile, setTranslateProfile] = useState(null);
    useEffect(() => {
        EnumCacheService.get('employeeprofile').then((data) => {
            setEmployeeProfiles((data || []).sort(dynamicSort('key')));
        });
    }, []);
    const getDefaultTranslation = (profileKey) => {
        const msgKey = PROFILE_MESSAGE_MAP[profileKey];
        if (!msgKey)
            return '';
        return intl.formatMessage(profileMessages[msgKey]);
    };
    return (_jsxs("div", Object.assign({ className: "control-panel subsection" }, { children: [_jsxs("div", Object.assign({ className: "title-block" }, { children: [_jsx("span", { children: intl.formatMessage(messages.EmployeeProfileTranslations) }), _jsx(HasMultiCompany, { children: _jsx("i", { className: "fa fa-fw fa-globe text-muted", title: intl.formatMessage(messages.ThisSettingIsAppliedToAllOwnCompanies) }) })] })), _jsx("div", Object.assign({ className: "panel-body container-fluid" }, { children: employeeProfiles.map(profile => (_jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("div", Object.assign({ className: "col-md-5" }, { children: _jsx("label", { children: getDefaultTranslation(profile.key) }) })), _jsx("div", Object.assign({ className: "col-md-7" }, { children: canUpdate ? (_jsx("a", Object.assign({ className: "form-control-static clickable bold", onClick: () => setTranslateProfile(profile), style: { cursor: 'pointer' } }, { children: _jsx("span", { children: formatListValue({
                                        list: 'employeeprofile',
                                        id: profile.key,
                                        fallback: getDefaultTranslation(profile.key),
                                        intl,
                                    }) }) }))) : (_jsx("p", Object.assign({ className: "form-control-static" }, { children: formatListValue({
                                    list: 'employeeprofile',
                                    id: profile.key,
                                    fallback: getDefaultTranslation(profile.key),
                                    intl,
                                }) }))) }))] }), profile.key))) })), translateProfile && (_jsx(TranslateListItemModal, { list: "employeeprofile", listId: String(translateProfile.key), fallback: getDefaultTranslation(translateProfile.key), show: !!translateProfile, onClose: () => setTranslateProfile(null), defaultRequired: false, maxLength: 250 }))] })));
};
export default EmployeeProfileTranslationsSection;
